import { render, staticRenderFns } from "./base_sidebar.vue?vue&type=template&id=9e8fdaba&scoped=true&"
import script from "./base_sidebar.vue?vue&type=script&lang=ts&"
export * from "./base_sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./base_sidebar.vue?vue&type=style&index=0&id=9e8fdaba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8fdaba",
  null
  
)

export default component.exports